export default __webpack_public_path__ + "static/media/you-get-one.5ab5756b.gif";